export const KIND_BASE = 80726;
